import React from 'react';
import { Search, Plus, Download } from 'lucide-react';
import AdvancedFilterPanel from '../AdvancedFilterPanel';
import { exportToCsv } from '../../utils/export';

/**
 * Devis page — search input + advanced filters + export CSV + "Nouveau devis".
 *
 * Kept stateless: parent owns search/filter state and the create dialog. We
 * avoid coupling to the quote handlers — the toolbar only fires the
 * `onCreate` callback. Export is handled in-place because it has no side
 * effects on the parent state.
 */
export default function DevisToolbar({
  search, setSearch,
  statuses, statusStyles,
  filterStatuses, setFilterStatuses,
  filterDateFrom, setFilterDateFrom,
  filterDateTo, setFilterDateTo,
  filterMinAmount, setFilterMinAmount,
  filterMaxAmount, setFilterMaxAmount,
  filteredCount, totalCount,
  filtered,
  onCreate,
}) {
  return (
    <div className="flex items-center gap-3 flex-wrap" data-testid="devis-toolbar">
      <div className="relative flex-1 max-w-md min-w-[240px]">
        <Search className="w-4 h-4 absolute left-3.5 top-1/2 -translate-y-1/2 text-[#8E8FA5]" />
        <input
          data-testid="devis-search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Rechercher un devis…"
          className="w-full h-10 pl-10 pr-4 rounded-xl bg-white border border-[#EFF0F6] text-[13.5px] focus:border-[#C7D2FE] outline-none"
        />
      </div>
      <AdvancedFilterPanel
        testId="devis-filter"
        statuses={statuses}
        selectedStatuses={filterStatuses}
        setSelectedStatuses={setFilterStatuses}
        statusStyles={statusStyles}
        dateFrom={filterDateFrom} setDateFrom={setFilterDateFrom}
        dateTo={filterDateTo} setDateTo={setFilterDateTo}
        minAmount={filterMinAmount} setMinAmount={setFilterMinAmount}
        maxAmount={filterMaxAmount} setMaxAmount={setFilterMaxAmount}
      />
      <div className="text-[11.5px] text-[#8E8FA5] font-medium whitespace-nowrap">
        {filteredCount} / {totalCount}
      </div>
      <button
        data-testid="devis-export-csv"
        onClick={() => exportToCsv('devis', filtered, ['id', 'client', 'program', 'amount', 'date', 'validUntil', 'status'])}
        className="h-10 px-3.5 rounded-xl bg-white border border-[#EFF0F6] text-[13px] font-medium text-[#4A4B63] flex items-center gap-2 hover:border-[#C7D2FE]"
      >
        <Download className="w-4 h-4" /> Exporter
      </button>
      <button
        data-testid="devis-create-btn"
        onClick={onCreate}
        className="h-10 px-4 rounded-xl brand-gradient text-white text-[13px] font-semibold flex items-center gap-2 shadow-sm ml-auto hover:opacity-95"
      >
        <Plus className="w-4 h-4" /> Nouveau devis
      </button>
    </div>
  );
}
